import * as React from 'react';
import * as styles from './styles.css';

export interface IReview {
  author: string;
  subtitle: string;
  date: string;
  text: string;
}

export interface IReviewsSectionProps {
  reviews: IReview[];
  rootRef: React.Ref<HTMLDivElement>;
  trackRef: React.Ref<HTMLDivElement>;
  prevButtonRef: React.Ref<HTMLButtonElement>;
  nextButtonRef: React.Ref<HTMLButtonElement>;
  onPrevClick: () => void;
  onNextClick: () => void;
  arrowIcon: string;
}

export const ReviewsSection: React.FC<IReviewsSectionProps> = ({
  reviews,
  rootRef,
  trackRef,
  prevButtonRef,
  nextButtonRef,
  onPrevClick,
  onNextClick,
  arrowIcon,
}) => (
  <section className={`${styles['reviews-section']} reveal`} aria-label="Отзывы клиентов">
    <div className={styles['reviews']}>
      <div className={styles['reviews__header']}>
        <h2 className={`${styles['reviews__title']} text-primary`}>Отзывы клиентов</h2>
        <div className={styles['reviews__controls']} aria-label="Листать отзывы">
          <button
            ref={prevButtonRef}
            className={`${styles['reviews__arrow']} ${styles['reviews__arrow--prev']}`}
            type="button"
            onClick={onPrevClick}
            data-reviews-prev
            aria-label="Назад"
          >
            <img src={arrowIcon} alt="" />
          </button>
          <button
            ref={nextButtonRef}
            className={styles['reviews__arrow']}
            type="button"
            onClick={onNextClick}
            data-reviews-next
            aria-label="Вперёд"
          >
            <img src={arrowIcon} alt="" />
          </button>
        </div>
      </div>
      <div ref={rootRef} className={styles['reviews-slider']} data-reviews-slider>
        <div ref={trackRef} className={styles['reviews-slider__track']} data-reviews-track>
          {reviews.map(review => (
            <article key={review.author + review.date} className={styles['review-card']}>
              <h5 className="text-primary">{review.author}</h5>
              <p className={`${styles['review-card__subtitle']} body2 text-secondary`}>{review.subtitle}</p>
              <div className={styles['review-card__rating']}>
                <span className={styles['review-card__stars']} aria-label="Оценка 5 из 5">
                  ★★★★★
                </span>
                <span className="body2 text-secondary">{review.date}</span>
              </div>
              <p className={`${styles['review-card__text']} body1 text-primary`}>{review.text}</p>
            </article>
          ))}
        </div>
      </div>
    </div>
  </section>
);
